module.exports = __webpack_public_path__ + "static/img/bg-kefe-icon.f087096.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/bg-kefe-icon.png
// module id = 1552
// module chunks = 0